import { render, staticRenderFns } from "./DesarrolloLandingVar2.vue?vue&type=template&id=251985c9&scoped=true"
import script from "./DesarrolloLandingVar2.vue?vue&type=script&lang=js"
export * from "./DesarrolloLandingVar2.vue?vue&type=script&lang=js"
import style0 from "./DesarrolloLandingVar2.vue?vue&type=style&index=0&id=251985c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251985c9",
  null
  
)

export default component.exports